import { teamMemberPermissionMatcher } from '@play/api-typings';
import { ifElse, compose, anyPass } from 'ramda';
import { filter, map } from 'rxjs/operators';
import { keyBy } from 'lodash';
import { entryAvailable } from '@play/state';

/**
 * Gets the name of a team
 *
 * @param team
 */
const getName = (team) => team.name;
/**
 * Gets the suffix of a team
 *
 * @param team
 */
const getSuffix = (team) => team.suffix;
/**
 * Gets the name + suffix of a team
 *
 * @param team
 */
const getCompleteName = ifElse(compose(Boolean, getSuffix), (team) => `${getName(team)} ${getSuffix(team)}`, getName);
/**
 * Checks if a team has premium or not
 *
 * @param team
 */
const hasPremium = (team) => team.premium;
/**
 * Gets the trustlevel of a team
 *
 * @param team
 */
const getTrustLevel = (team) => team.trustLevel;
/**
 * Checks if a Team has trusted or not
 *
 * @param Team
 */
const hasTrusted = compose(Boolean, getTrustLevel);
/**
 * Gets the id of a team
 *
 * @param team
 */
const getId = (team) => +team.id;
/**
 * Checks if user is leader
 *
 * @param membership
 */
const isLeader = (membership) => membership.permission === teamMemberPermissionMatcher.leader;
/**
 * Checks if user is coleader
 *
 * @param membership
 */
const isCoLeader = (membership) => membership.permission === "co_leader";
/**
 * Checks if user has permissions to edit team
 *
 * @param membership
 */
const canEditTeam = anyPass([isLeader, isCoLeader]);

const teamsToDictionary = () => {
    return teams$ => teams$.pipe(filter(teams => teams.size && teams.every(({ loading }) => !loading) && teams.every(entryAvailable)), map(teams => teams.toArray().map(({ entry }) => entry)), map(teams => keyBy(teams, "id")));
};

/**
 * Generated bundle index. Do not edit.
 */

export { canEditTeam, getCompleteName, getId, getName, getSuffix, getTrustLevel, hasPremium, hasTrusted, isCoLeader, isLeader, teamsToDictionary };
//# sourceMappingURL=play-utility-team.js.map
